import { render, staticRenderFns } from "./multPapers.vue?vue&type=template&id=7fb5bb00&scoped=true&"
import script from "./multPapers.vue?vue&type=script&lang=js&"
export * from "./multPapers.vue?vue&type=script&lang=js&"
import style0 from "./multPapers.vue?vue&type=style&index=0&id=7fb5bb00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb5bb00",
  null
  
)

export default component.exports